import React from 'react';
import Draggable from 'react-draggable';
import { getTouchPosition } from '../utils/TransformToolUtils';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import dragManager from '../utils/DragManager';
import createShapes from '../utils/CreateShapes';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import appParameters from '../../components/utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import {changeContextMode} from '../../actions/MenuActions';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var caption = locales.getCaption('mainMenuShapes', 'hover');

        var closeButtonStyle = {
            position: 'absolute',
            width: 24,
            height: 24,
            top: 3,
            right: 28,
            cursor: 'pointer',
            borderStyle: 'none',
            background: 'none',
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 4,
            right: 4,
            cursor: 'pointer'
        };

        var ariaLabel = locales.getCaption('exit', 'other') + ' ' + caption;

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{caption}</span>
                <button id="leftShapesMenuFirstFocusabletElement" aria-label={ariaLabel} style={closeButtonStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            clientX: 0,
            clientY: 0
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onMouseDown (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (platformDetection.isTouchableDevice() == true) {
            const clientPosition = mouseUtils.getTouchPosition(e);

            this.setState({
                clientX: clientPosition.x,
                clientY: clientPosition.y
            });
        }
    },
    onMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5)
            this.createShape();
    },
    onMouseClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.createShape();
    },
    createShape (topLeftPosition) {
        const { dispatch } = this.props;

        switch (this.props.index) {
            case 0: { // rectangle
                createShapes.createRectangle(dispatch, topLeftPosition);
                break;
            }

            case 1: { // ellipse
                createShapes.createEllipse(dispatch, topLeftPosition);
                break;
            }

            case 2: { // curve
                createShapes.createCurve(dispatch, topLeftPosition);
                break;
            }

            case 3: { // triangle
                createShapes.createTriangle(dispatch, topLeftPosition);
                break;
            }

            case 4: { // Star
                createShapes.createStar(dispatch, topLeftPosition);
                break;
            }

            case 5: { // Heart
                createShapes.createHeart(dispatch, topLeftPosition);
                break;
            }
        }

        this.changeFocusToShapeMenuButton();
    },
    changeFocusToShapeMenuButton() {
        if (platformDetection.isIOS())
            return;

      setTimeout(function() {
          var shapeMenuButton = document.getElementById('shapeMenuButton');

          if (shapeMenuButton)
              shapeMenuButton.focus();
      }.bind(this), 100);
    },
    onDragStart(e) {
        if (platformDetection.isTouchableDevice() == true)
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clone = this.refs.itemRenderer;

        dragManager.prepareClone(clone, this.createShape, getTouchPosition(e));
    },
    onDragMove(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true)
            return;

        dragManager.onDragMove(coreEvent.lastX, coreEvent.lastY);
    },
    onDragEnd(e, coreEvent) {
        if (platformDetection.isTouchableDevice() == true)
            return;

        dragManager.onDragEnd(coreEvent.lastX, coreEvent.lastY);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.state.isMouseIn != nextState.isMouseIn)
            return true;
        else
            return false;
    },
    render() {
        const buttonWidth = this.props.buttonWidth;
        const buttonHeight = this.props.buttonHeight;
        var frameDisplayState;
        var frameColor;
        var iconSrc = this.props.src;

        if (this.state.isOver == true) {
            frameDisplayState = 'block';
            frameColor = properties.SLIDE_FRAME_HOVER_COLOR;
        } else {
            frameDisplayState = 'none';
            frameColor = 'black';
        }

        var buttonStyle = {
            position: 'absolute',
            left: this.props.left,
            top: this.props.top,
            width: buttonWidth,
            height: buttonHeight,
            background: 'white',
            cursor: '-webkit-grab',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            display: 'flex',
            borderStyle: 'none'
        };

        const boderWidth = 2;

        const frameStyle = {
            position: 'absolute',
            width: buttonWidth - 2 * boderWidth,
            height: buttonHeight - 2 * boderWidth,
            borderWidth: boderWidth,
            borderStyle: 'solid',
            borderColor: frameColor,
            top: 0,
            display: frameDisplayState
        };

        var iconWidth = 75;
        var leftPos = 30;
        var topPos = 10;

        if (platformDetection.isIOS() == true) {
            iconWidth = 55;
            leftPos = 17;
            topPos = 0;
        }

        const iconStyle = {
            position: 'absolute',
            width: iconWidth,
            left: leftPos,
            top: topPos
        };

        var spanStyle = {
            position: 'absolute',
            top: buttonHeight - 35,
            width: buttonWidth - 10,
            textAlign: 'center',
            left: 5,
            fontSize: 14,
            color: frameColor
        };

        const draggableStyle = {
            position: 'absolute',
            width: buttonWidth,
            height: buttonHeight,
            top: 0,
            background: 'red',
            opacity: 0,
            display: 'block'
        };

        if (platformDetection.isIOS() == true) {
            spanStyle.fontSize = 12;
            spanStyle.top = buttonHeight - 20;
        }

        var idValue = this.props.index == 0 ? 'firstFocusableObject' : undefined;

        if (this.props.index == 5)
            idValue = 'leftShapesMenuLastFocusabletElement';

        return (
            <button id={idValue} ref='itemRenderer' aria-label={this.props.text} style={buttonStyle} onClick={this.onMouseClick} onTouchStart={this.onMouseDown} onTouchEnd={this.onMouseUp} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>
                <span style={spanStyle}>{this.props.text}</span>
                <div style={frameStyle}/>
                <Draggable axis='none' position={{x:0, y:0}} onStart={this.onDragStart} onDrag={this.onDragMove} onStop={this.onDragEnd}>
                    <div style={draggableStyle}/>
                </Draggable>
            </button>
        );
    }
});

export const LeftShapesMenu = React.createClass({
    getInitialState() {
        return {
            buttons: []
        };
    },
    componentDidMount() {
        this.initElements();

        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    initElements() {
        var buttons = [];
        var leftGap = 20;
        var middleGap = 10;

        if (platformDetection.isIOS() == true)
            leftGap = 18;

        const buttonWidth = (properties.BROWSER_WIDTH - 2 * leftGap - middleGap) / 2;
        const buttonHeight = buttonWidth - 20;

        buttons.push(<Button index={0} dispatch={this.props.dispatch} text={locales.getCaption('Rectangle', 'shapes')} src={appParameters.RESOURCES_LOCATION() + 'assets/rectangle.png'} buttonWidth={buttonWidth} buttonHeight={buttonHeight} left={leftGap} top={leftGap} key='shapesMenu3'/>);
        buttons.push(<Button index={1} dispatch={this.props.dispatch} text={locales.getCaption('Ellipse', 'shapes')} src={appParameters.RESOURCES_LOCATION() + 'assets/ellipse.png'} buttonWidth={buttonWidth} buttonHeight={buttonHeight} left={leftGap + middleGap + buttonWidth} top={leftGap} key='shapesMenu4'/>);
        buttons.push(<Button index={2} dispatch={this.props.dispatch} text={locales.getCaption('Curve', 'shapes')} src={appParameters.RESOURCES_LOCATION() + 'assets/curve.png'} buttonWidth={buttonWidth} buttonHeight={buttonHeight} left={leftGap} top={leftGap + middleGap + buttonHeight} key='shapesMenu5'/>);
        buttons.push(<Button index={3} dispatch={this.props.dispatch} text={locales.getCaption('Triangle', 'shapes')} src={appParameters.RESOURCES_LOCATION() + 'assets/triangle.png'} buttonWidth={buttonWidth} buttonHeight={buttonHeight} left={leftGap + middleGap + buttonWidth} top={leftGap + middleGap + buttonHeight} key='shapesMenu6'/>);
        buttons.push(<Button index={4} dispatch={this.props.dispatch} text={locales.getCaption('Star', 'shapes')} src={appParameters.RESOURCES_LOCATION() + 'assets/star.png'} buttonWidth={buttonWidth} buttonHeight={buttonHeight} left={leftGap} top={leftGap + 2 * middleGap + 2 * buttonHeight} key='shapesMenu7'/>);
        buttons.push(<Button index={5} dispatch={this.props.dispatch} text={locales.getCaption('Heart', 'shapes')} src={appParameters.RESOURCES_LOCATION() + 'assets/heart.png'} buttonWidth={buttonWidth} buttonHeight={buttonHeight} left={leftGap + middleGap + buttonWidth} top={leftGap + 2 * middleGap + 2 * buttonHeight} key='shapesMenu8'/>);

        this.setState({
            buttons
        });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.buttons != nextState.buttons || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        if (this.state == undefined || this.state.buttons == undefined)
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var listHeight = this.props.windowHeight - properties.CLIPART_BUTTON_HEIGHT;
        var componentProperties = {};
        var leftGap = 20;
        var middleGap = 10;

        if (platformDetection.isIOS() == true)
            leftGap = 18;

        const buttonWidth = (properties.BROWSER_WIDTH - 2 * leftGap - middleGap) / 2;
        const buttonHeight = buttonWidth - 20;

        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = listHeight;
        componentProperties.top = properties.CLIPART_BUTTON_HEIGHT;
        componentProperties.elements = this.state.buttons;
        componentProperties.scrollHeight = 3 * buttonHeight + 5 * middleGap;

        return (
            <div style={menuStyle} id="leftShapesMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/LeftShapesMenu.js
 **/